export const enum BeachVolleyballResultId {
  FirstSet = 43,
  SecondSet = 44,
  ThirdSet = 45,
  GoldenSet = 410,
}
